import { render, staticRenderFns } from "./BrandingColoursCSS.vue?vue&type=template&id=5b17eb84"
import script from "./BrandingColoursCSS.vue?vue&type=script&lang=js"
export * from "./BrandingColoursCSS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports